import script from "./topBg.vue?vue&type=script&setup=true&lang=js"
export * from "./topBg.vue?vue&type=script&setup=true&lang=js"

import "./topBg.vue?vue&type=style&index=0&id=b49ec658&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b49ec658"]])

export default __exports__